// ======================================================================
// File Name       : archivement
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../constants/actionTypes/archivement';

const initialState = {
  recordNum: 0,
  userList: [],
  userDetailList: [],
  reportList: [],
  managementAuthorityList: [],
  reportOperationCountList: [],
  managementAuthoritys: {
    bySecernId: {},
    allSecernIds: [],
  },
  userAttributes: {
    byKeyNum: {},
    allKeyNums: [],
  },
  userInfo: {
    bySecernId: {},
    allSecernIds: [],
  },
  userDetailInfo: {
    bySecernId: {},
    allSecernIds: [],
  },
  reportInfo: {
    bySecernId: {},
    allSecernIds: [],
  },
  reportOperationCountInfo: {
    bySecernId: {},
    allSecernIds: [],
  },
  reportApprovalDateFrom: null,
  reportApprovalDateTo: null,
};

export default function archivement(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.USER_RECEIVE_AUTHORITY_LIST: {
      const { managementAuthorityList } = action;
      managementAuthorityList.splice(0, 0, {
        managementAuthoritySecernId: null,
        managementAuthorityName: null,
      });
      const managementAuthoritys = managementAuthorityList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.managementAuthoritySecernId] = cur;
          acc.allSecernIds.push(cur.managementAuthoritySecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      return {
        ...state,
        ...{ managementAuthorityList, managementAuthoritys },
      };
    }
    case ActionTypes.USER_RECEIVE_USER_LIST: {
      const { userList, recordNum, reportApprovalDateFrom, reportApprovalDateTo } = action;
      const userInfo = userList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.userSecernId] = cur;
          acc.allSecernIds.push(cur.userSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      return {
        ...state,
        ...{ userList },
        ...{ userInfo },
        ...{ recordNum },
        ...{ reportApprovalDateFrom },
        ...{ reportApprovalDateTo },
      };
    }
    case ActionTypes.USER_RECEIVE_REPORT_OPERATION_COUNT: {
      const { reportOperationCountList } = action;
      let { reportOperationCountInfo } = initialState;
      if (reportOperationCountList) {
        reportOperationCountInfo = reportOperationCountList.reduce(
          (acc, cur) => {
            acc.bySecernId[cur.checkerUserSecernId] = cur;
            acc.allSecernIds.push(cur.checkerUserSecernId);
            return acc;
          },
          {
            bySecernId: {},
            allSecernIds: [],
          },
        );
      }
      return {
        ...state,
        ...{ reportOperationCountList, reportOperationCountInfo },
      };
    }
    case ActionTypes.USER_RECEIVE_REPORT_OPERATION_LIST: {
      const { reportList, recordNum } = action;
      const reportInfo = reportList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.userSecernId] = cur;
          acc.allSecernIds.push(cur.userSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      return {
        ...state,
        ...{ reportList },
        ...{ reportInfo },
        ...{ recordNum },
      };
    }
    case ActionTypes.USER_RECEIVE_MAPPING_USER: {
      const { userDetailList } = action;

      const userDetailInfo = userDetailList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.userSecernId] = cur;
          acc.allSecernIds.push(cur.userSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );

      return {
        ...state,
        ...{ userDetailList },
        ...{ userDetailInfo },
      };
    }
    default:
      return state;
  }
}
